export const LOAD_ENUM_GROUP_DATA_IN_PROGRESS = "LOAD_ENUM_GROUP_DATA_IN_PROGRESS";
export const loadEnumGroupDataInProgress = () => ({
  type: LOAD_ENUM_GROUP_DATA_IN_PROGRESS,
});

export const LOAD_ENUM_GROUP_DATA_SUCCESS = "LOAD_ENUM_GROUP_DATA_SUCCESS";
export const loadEnumGroupDataSuccess = (data) => ({
  type: LOAD_ENUM_GROUP_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_ENUM_GROUP_DATA_FAILURE = "LOAD_ENUM_GROUP_DATA_FAILURE";
export const loadEnumGroupDataFailure = () => ({
  type: LOAD_ENUM_GROUP_DATA_FAILURE,
});

export const OPEN_ENUMS_GROUP_DIALOG = "OPEN_ENUMS_GROUP_DIALOG";
export const openEnumsGroupDialog = () => ({
  type: OPEN_ENUMS_GROUP_DIALOG,
});

export const CLOSE_ENUMS_GROUP_DIALOG = "CLOSE_ENUMS_GROUP_DIALOG";
export const closeEnumsGroupDialog = () => ({
  type: CLOSE_ENUMS_GROUP_DIALOG,
});

export const LOAD_ENUM_GROUP_SINGLE_DATA = "LOAD_ENUM_GROUP_SINGLE_DATA";
export const loadEnumGroupSingleData = (data) => ({
  type: LOAD_ENUM_GROUP_SINGLE_DATA,
  payload: { data },
});

export const ENUM_GROUP_OPERATION_COMPLETED = "ENUM_GROUP_OPERATION_COMPLETED";
export const enumGroupOperationCompleted = () => ({
  type: ENUM_GROUP_OPERATION_COMPLETED,
});